import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Spinner } from '../../npaper';
import { IProductGroup, useStores } from '../../stores';
import { FormattedMessage } from 'react-intl';

export const ProductGroupTitle = observer(
  ({ productGroupId }: { productGroupId: number | string }) => {
    const { productGroupStore } = useStores();
    const [contactGroup, setContactGroup] = useState<IProductGroup>();
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
      let isSub = true;

      const t = setTimeout(() => {
        isSub && setNotFound(true);
      }, 5000);

      productGroupStore.getItemNaiveAsync(productGroupId).then((g) => {
        if (isSub) {
          clearTimeout(t);
          setContactGroup(g);
        }
      });
      return () => {
        isSub = false;
        clearTimeout(t);
      };
    }, [productGroupId, productGroupStore]);

    if (notFound && !contactGroup) {
      return (
        <p className="muted danger">
          <FormattedMessage
            defaultMessage="Not found: {groupId}"
            values={{ groupId: productGroupId }}
            description="Product group could not be found (timed out)"
          />
        </p>
      );
    }

    return contactGroup ? <>{contactGroup.name}</> : <Spinner size={16} />;
  }
);
